import React from "react";
import classNames from "classnames";
import { has } from "lodash";

import { DownloadButton } from "@api/components/DownloadButton";
import { messages } from "@api/messages";
import { enhancedWithRowData, CellPropsWithRow } from "@ui/Table/Cells";
import { WaIcon } from "@ui/WaIcon";
import { Report } from "../../models";
import { FormattedMessage } from "react-intl";

// Function to calculate the percentage of time elapsed between two dates
const percentageElapsed = (start: Date, end: Date): number => {
    const now = (new Date()).getTime();
    const startTime = start.getTime();
    const endTime = end.getTime();
    return Math.round((1 - ((endTime - now) / (endTime - startTime))) * 100);
};

interface EntityRow {
    entity: Report;
}
export const CellDownloadFilesPresenter = (props: CellPropsWithRow & { rowData: Report | EntityRow }) => {
    let report: Report = has(props.rowData, "entity") ? props.rowData.entity : props.rowData;
    // Handle griddle converting records to JS objects.
    if (!(report instanceof Report)) {
        report = new Report(report);
    }

    // Get the download buttons mapped.
    const now = new Date();
    const availableAt = report.availableAt == null ? now : new Date(report.availableAt);
    const createdAt = new Date(report.createdAt);
    const isAvailable = report.availableAt == null || availableAt < now;
    const fileLinks = report.getFiles().map((file, index) => {
        let buttonText = null;
        // if (file.format != null) {
        //     buttonText = Localisation.translateMap(file.format.labelShort);
        // }
        buttonText = file.origFilename;
        return (
            <DownloadButton
                url={file.url}
                style="text"
                key={index}
                disabled={!isAvailable}
            >
                <WaIcon name="download" />
                <FormattedMessage {...messages.downloadButtonExt} values={{ ext: file.formatExt }} />
            </DownloadButton>
        );
    });

    return (
        <div className={
            classNames("cell-download-files", {
                "cell-download-files--progress": !isAvailable,
            })
        }>
            {!isAvailable &&
                <span
                    className="btn-progress"
                    style={{width: percentageElapsed(createdAt, availableAt) + "%"}}
                ></span>
            }
            <>{fileLinks}</>
        </div>
    );
};

export const CellDownloadFiles = enhancedWithRowData(CellDownloadFilesPresenter);
